import {
  EntityMember,
  Member,
  MemberComponent,
  MemberInitState,
  MemberTimeInformation
} from '@/store/member/member.types';
import {MemberAction} from '@/store/member/member.actions';
import {MemberMutations} from '@/store/member/member.mutations';
import {ServiceFormSearch} from '@/class/service-form.interface';


const namespaced = true;

export const memberInitState: MemberInitState = {
  member: [] as Member[],
  profile: {} as EntityMember,
  bondsman: {} as Member,
  getMemberFromService: [] as Member[],
  serviceFormSearch: {} as ServiceFormSearch,
  inviteList: [],
  timeInformation: {} as MemberTimeInformation,
  component: {
    profileVisit: {}
  } as MemberComponent,
  checkMobile: 0,
  timeTotal: ''
};

export const memberState = {
  namespaced,
  state: memberInitState,
  actions: MemberAction,
  mutations: MemberMutations,
  // getters
};
